import { render, staticRenderFns } from "./orderPayChoose.vue?vue&type=template&id=85c12fde&scoped=true&"
import script from "./orderPayChoose.vue?vue&type=script&lang=js&"
export * from "./orderPayChoose.vue?vue&type=script&lang=js&"
import style0 from "./orderPayChoose.vue?vue&type=style&index=0&id=85c12fde&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c12fde",
  null
  
)

export default component.exports